import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IUserView } from '../models/users/user-result';
import { IUserProfile } from '../models/users/userProfile';
import { IUserGroups } from '../models/users/userGroups';
import { UserCreate } from '../models/users/userCreate';
import { UserUpdate } from '../models/users/userUpdate';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpClient) {}

  listUsers(): Observable<{ users: IUserView[] }> {
    const url = `${environment.apiBase}/users`;
    if (isDevMode()) {
      console.log('[DEV] [UsersService] loading users');
    }
    return this.http.get<{ users: IUserView[] }>(url, httpOptions);
  }

  createUser(newUser: UserCreate): Observable<{ user: IUserView }> {
    const url = `${environment.apiBase}/users`;
    return this.http.post<{ user: IUserView }>(url, newUser, httpOptions);
  }

  updateUser(id: string, updateBody: UserUpdate): Observable<{ user: IUserView }> {
    const url = `${environment.apiBase}/users/${id}`;
    return this.http.put<{ user: IUserView }>(url, updateBody, httpOptions);
  }

  updateUserGroups(id: string, body: IUserGroups): Observable<{ user: IUserView }> {
    const url = `${environment.apiBase}/users/${id}/groups`;
    if (isDevMode()) {
      console.log('[DEV] [UsersService] updating user groups', body.groups);
    }
    return this.http.post<{ user: IUserView }>(url, body, httpOptions);
  }

  updateUserProfileImage(id: string, file: File): Observable<{ user: IUserView }> {
    const url = `${environment.apiBase}/users/ProfileImage/${id}`;
    if (isDevMode()) {
      console.log('[DEV] [UsersService] updating user profile image', id);
    }
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.put<{ user: IUserView }>(url, formData);
  }

  updateClientProfileImage(id: string, file: File): Observable<{ user: IUserView }> {
    const url = `${environment.apiBase}/users/ProfileImage/me`;
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.put<{ user: IUserView }>(url, formData);
  }

  resendInvite(id: string): Observable<{ id: string }> {
    const url = `${environment.apiBase}/users/${id}/resend-invite`;
    return this.http.post<{ id: string }>(url, {}, httpOptions);
  }

  deleteUser(user: IUserView): Observable<{ id: string }> {
    if (isDevMode()) {
      console.log('[DEV] [UsersService] deleting user', user.id);
    }
    const url = `${environment.apiBase}/users/${user.id}`;
    return this.http.delete<{ id: string }>(url, httpOptions);
  }

  getProfile(): Observable<IUserProfile> {
    const url = `${environment.apiBase}/profile`;
    return this.http.get<IUserProfile>(url, httpOptions);
  }
}
